import React from 'react'
import { withIcon } from '../../withIcon'

function TelegramIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M21.4133 3.53114C21.5885 3.68562 21.663 3.92495 21.6063 4.1516L17.6063 20.1516C17.5517 20.37 17.3838 20.5422 17.1668 20.6023C16.9498 20.6624 16.7173 20.6012 16.5581 20.442L12.0676 15.9515L9.5 19.375C9.36052 19.561 9.12935 19.6542 8.89989 19.6169C8.67043 19.5797 8.48059 19.4182 8.40708 19.1977L6.48894 13.4433L2.72049 11.559C2.49938 11.4485 2.36421 11.218 2.37568 10.971C2.38714 10.7241 2.54307 10.5071 2.77347 10.4175L20.7735 3.41751C20.9912 3.33283 21.238 3.37666 21.4133 3.53114ZM12.4495 14.5656C12.4449 14.5609 12.4402 14.5562 12.4355 14.5516L11.8839 14L15.4419 10.442C15.686 10.1979 15.686 9.80215 15.4419 9.55807C15.1979 9.31399 14.8021 9.31399 14.5581 9.55807L10.5581 13.5581C10.314 13.8021 10.314 14.1979 10.5581 14.442L11.1748 15.0587L9.21572 17.6707L7.59293 12.8024C7.54051 12.6451 7.42777 12.5151 7.27951 12.441L4.54054 11.0715L20.1007 5.02034L16.6614 18.7775L12.4495 14.5656Z" fill={color}/>
    </svg>
  )
}

export default withIcon(TelegramIcon)
